/* Dauber HQ nav — cookie-driven CTA swap + mobile hamburger toggle. */

(function () {
  'use strict';

  function isLoggedIn() {
    return document.cookie.split(';').some(function (c) {
      return c.trim().indexOf('dhq_logged_in=1') === 0;
    });
  }

  function swapCTA() {
    if (!isLoggedIn()) return;
    var cta = document.querySelector('[data-nav-cta]');
    if (cta) {
      cta.innerHTML =
        '<a class="btn btn--primary btn--sm" href="https://app.dauberhq.com/" data-track="cta_app_return_click">Go to app <span class="btn-arrow">→</span></a>';
    }
    // Mirror the swap inside the mobile panel — the top-bar CTA is hidden there.
    var panelCta = document.querySelector('[data-nav-panel-cta]');
    if (panelCta) {
      panelCta.innerHTML =
        '<a class="btn btn--primary" href="https://app.dauberhq.com/" data-track="cta_app_return_click">Go to app <span class="btn-arrow">→</span></a>';
    }
  }

  function wireHamburger() {
    var toggle = document.querySelector('.nav__toggle');
    var panel  = document.getElementById('nav-panel');
    if (!toggle || !panel) return;

    function background() {
      return Array.prototype.slice.call(document.querySelectorAll('main, footer'));
    }
    function focusables() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('a[href], button:not([disabled])')
      );
    }
    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function open() {
      panel.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      // Hide the page behind the full-screen overlay from keyboard + AT.
      background().forEach(function (el) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); });
      var f = focusables();
      if (f.length) f[0].focus();
    }

    function close() {
      panel.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      background().forEach(function (el) { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); });
      toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close(); else open();
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Close on link click inside panel (theme button is excluded — it's not an <a>).
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
  }

  function init() {
    swapCTA();
    wireHamburger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
